// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"Spinner_loadingWrapper__kUZlq","spinner":"Spinner_spinner__JxGp1","spin":"Spinner_spin__OVQQj"};